const queryFiltersMappings = {
  eq: (key, value) => {
    return `${key} eq ${value[0]}`
  },
  gte: (key, value) => {
    return `${key.replace(/:gte/g, '')} gte ${value}`
  },
  lte: (key, value) => {
    return `${key.replace(/:lte/g, '')} lte ${value}`
  },
  in: (key, values) => {
    const formattedValues = values.map((value) => `${value}`)
    return `${key.replace(/:in/g, '')} in (${formattedValues.join(' ')})`
  },
}

const filterMappings = {
  'status.name': queryFiltersMappings.eq,
  'created_on:gte': queryFiltersMappings.gte,
  'created_on:lte': queryFiltersMappings.lte,
  'load_weight:gte': queryFiltersMappings.gte,
  'load_weight:lte': queryFiltersMappings.lte,
  'load_volume:gte': queryFiltersMappings.gte,
  'load_volume:lte': queryFiltersMappings.lte,
  'shipped_customer.id:in': queryFiltersMappings.in,
  'vendor.id:in': queryFiltersMappings.in,
  'origin_address.id:in': queryFiltersMappings.in,
  'destination_address.id:in': queryFiltersMappings.in,
}

export default filterMappings
